import React, { Suspense } from 'react';
import { useParams } from 'react-router-dom';
import UILoader from 'components/UI/Loader/Loader';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';

const CampaignForm = React.lazy(() => import('components/Campaign/Form/Form'));

function ScreensTraditionalCampaignForm() {
  let { id } = useParams();
  id = id ? parseInt(id, 10) : null;

  return (
    <BaseLayout className="background-blue">
      <DocumentTitle>{id ? 'Edit' : 'Create'} Campaign</DocumentTitle>
      <Suspense fallback={<UILoader />}>
        <CampaignForm id={id} key={id} />
      </Suspense>
    </BaseLayout>
  );
}

export default ScreensTraditionalCampaignForm;
